import { Box, Typography } from "@mui/material";
import React from "react";

const Page401 = () => {
  return (
    <Box className="flex flex-col w-full h-full items-center justify-center">
      <Typography variant="h3">{401}</Typography>
      <div>You aren't authorized to see this!</div>
    </Box>
  );
};

export default Page401;
